module.exports = "/img/_/_/_/assets/images/icon//uncommon.png?f5e8973765844784ba5ea8dcf66c0a15";